export const BACKEND_PREFIX = '/backend'
